module.exports = __webpack_public_path__ + "static/media/deleteIcon.4b7141bd.svg";